import { Modal } from "antd";
import styled from "styled-components";

import {
  PurchaseContent,
  PurchaseContentProps,
} from "./common/PurchaseContent";

export const PurchasePopup = ({
  isOpened,
  onClose,
  ...purchaseContentProps
}: {
  isOpened?: boolean;
  onClose?: () => void;
} & PurchaseContentProps) => {
  return (
    <StyledModal
      open={isOpened}
      onClose={onClose}
      onCancel={onClose}
      width={1000}
      centered
      destroyOnClose
      footer={null}
    >
      <PurchaseContent {...purchaseContentProps} />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
  }
`;
